import React, { useEffect, useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const EMPTY_FORM = {
  firstName: '',
  lastName: '',
  email: '',
  role: 'Staff',
};

const ROLE_OPTIONS = [
  { value: 'Staff', label: 'Staff' },
  { value: 'Admin', label: 'Admin' },
];

const InviteStaffModal = ({ isOpen, onClose, onSubmit, isSubmitting }) => {
  const [form, setForm] = useState(EMPTY_FORM);

  useEffect(() => {
    if (isOpen) {
      setForm(EMPTY_FORM);
    }
  }, [isOpen]);

  const updateField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onSubmit({
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      email: form.email.trim(),
      role: form.role,
    });
  };

  const handleClose = () => {
    if (!isSubmitting) onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Invite Team Member" maxWidth="max-w-lg">
      <form onSubmit={handleSubmit} className="space-y-5">
        <p className="text-sm text-muted-foreground font-caption">
          They will receive a secure email link to create their password and join this workspace.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="First name"
            value={form.firstName}
            onChange={(event) => updateField('firstName', event.target.value)}
            required
            autoComplete="given-name"
            disabled={isSubmitting}
          />
          <Input
            label="Last name"
            value={form.lastName}
            onChange={(event) => updateField('lastName', event.target.value)}
            required
            autoComplete="family-name"
            disabled={isSubmitting}
          />
        </div>

        <Input
          type="email"
          label="Email address"
          value={form.email}
          onChange={(event) => updateField('email', event.target.value)}
          required
          autoComplete="email"
          disabled={isSubmitting}
        />

        <Select
          label="Role"
          value={form.role}
          options={ROLE_OPTIONS}
          onChange={(value) => updateField('role', value)}
          description={form.role === 'Admin'
            ? 'Admins can manage staff, company settings, bookings, orders, and services.'
            : 'Staff can sign in and process workflow stages assigned to them.'}
          required
          disabled={isSubmitting}
        />

        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 pt-2">
          <Button type="button" variant="outline" onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button type="submit" loading={isSubmitting} iconName="Send">
            Send Invitation
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default InviteStaffModal;
